import script from "./Uploader.vue?vue&type=script&setup=true&lang=ts"
export * from "./Uploader.vue?vue&type=script&setup=true&lang=ts"

import "./Uploader.vue?vue&type=style&index=0&id=4cfa212e&lang=scss"

const __exports__ = script;

export default __exports__
import QTr from 'quasar/src/components/table/QTr.js';
import QBanner from 'quasar/src/components/banner/QBanner.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../portal/node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QTr,QBanner,QBtn});
